import { Box, Link } from '@gazin/ecommerce-ui'
import { FaFacebookF, FaTwitter, FaWhatsapp } from 'react-icons/fa'
import { getStyles } from './styles'

type ModalShareProps = {
  showShare: boolean
  URLShare: string
}

export const ModalShare: React.FC<ModalShareProps> = ({
  showShare,
  URLShare,
}) => {
  const styles = getStyles()

  return (
    <Box
      alignItems="center"
      background="white"
      borderRadius="100%"
      boxShadow="0.0625rem 0.125rem 0.4048rem #16182921"
      data-testid="modal-share"
      display={showShare ? 'flex' : 'none'}
      flexDirection="row"
      flexWrap="wrap"
      height="8.75rem"
      padding="0.625rem"
      position="absolute"
      right="-0.5rem"
      top="-2.3rem"
      width="8.75rem"
    >
      <Link
        href={`https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${encodeURIComponent(
          URLShare
        )}&display=popup&ref=plugin&src=share_button`}
        rel="noopener noreferrer"
        target="_blank"
        {...styles.shareOptions}
      >
        <FaFacebookF color="#3C85FF" size={28} />
      </Link>

      <Link
        href={`https://wa.me/?text=${encodeURIComponent(URLShare)}`}
        rel="noopener noreferrer"
        target="_blank"
        {...styles.shareOptions}
      >
        <FaWhatsapp color="#3C85FF" size={28} />
      </Link>

      <Link
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          URLShare
        )}`}
        rel="noopener noreferrer"
        target="_blank"
        {...styles.shareOptions}
      >
        <FaTwitter color="#3C85FF" size={28} />
      </Link>
    </Box>
  )
}
